var _defs, _g, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    width: 126,
    height: 126
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect818",
    fill: "#f5f6f8",
    strokeWidth: 0,
    d: "M.5.39h126v126H.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.757 7.606V44.69l12.995-7.822 12.994 7.822V7.606"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.607 7.379h110.685v110.685H7.607z"
  })));
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0ic3ZnOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTI2IiBoZWlnaHQ9IjEyNiIgdmlld0JveD0iMCAwIDEyNiAxMjYiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICNmNWY2Zjg7CiAgICAgICAgc3Ryb2tlLXdpZHRoOiAwcHg7CiAgICAgIH0KCiAgICAgIC5jbHMtMiB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgICBzdHJva2U6ICMyMTI1Mjk7CiAgICAgICAgc3Ryb2tlLW1pdGVybGltaXQ6IDEwOwogICAgICAgIHN0cm9rZS13aWR0aDogMnB4OwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8ZyBpZD0ibGF5ZXIyIj4KICAgIDxyZWN0IGlkPSJyZWN0ODE4IiBjbGFzcz0iY2xzLTEiIHg9Ii41IiB5PSIuMzkiIHdpZHRoPSIxMjYiIGhlaWdodD0iMTI2Ii8+CiAgPC9nPgogIDxwb2x5bGluZSBjbGFzcz0iY2xzLTIiIHBvaW50cz0iNDkuNzU3IDcuNjA2IDQ5Ljc1NyA0NC42OSA2Mi43NTIgMzYuODY4IDc1Ljc0NiA0NC42OSA3NS43NDYgNy42MDYiLz4KICA8cmVjdCBjbGFzcz0iY2xzLTIiIHg9IjcuNjA3IiB5PSI3LjM3OSIgd2lkdGg9IjExMC42ODUiIGhlaWdodD0iMTEwLjY4NSIvPgo8L3N2Zz4=";
export { SvgComponent as ReactComponent };